import { useRef, useState } from "react";

export function useFirmaCanvas(onChange) {
  const canvasRef = useRef(null);
  const pointerRef = useRef(null);
  const [firmada, setFirmada] = useState(false);

  const punto = event => {
    const canvas = canvasRef.current;
    const bounds = canvas.getBoundingClientRect();
    return {
      x: (event.clientX - bounds.left) * canvas.width / bounds.width,
      y: (event.clientY - bounds.top) * canvas.height / bounds.height,
    };
  };

  const iniciar = event => {
    if (pointerRef.current !== null || (event.pointerType === "mouse" && event.button !== 0)) {
      return;
    }
    event.preventDefault();
    const canvas = canvasRef.current;
    pointerRef.current = event.pointerId;
    canvas.setPointerCapture(event.pointerId);
    const context = canvas.getContext("2d");
    const { x, y } = punto(event);
    context.strokeStyle = "#171717";
    context.fillStyle = "#171717";
    context.lineWidth = 3;
    context.lineCap = "round";
    context.lineJoin = "round";
    context.beginPath();
    context.arc(x, y, 1.5, 0, Math.PI * 2);
    context.fill();
    context.beginPath();
    context.moveTo(x, y);
    setFirmada(true);
    onChange(null);
  };

  const dibujar = event => {
    if (pointerRef.current !== event.pointerId) return;
    event.preventDefault();
    const context = canvasRef.current.getContext("2d");
    const { x, y } = punto(event);
    context.lineTo(x, y);
    context.stroke();
  };

  const terminar = event => {
    if (pointerRef.current !== event.pointerId) return;
    const canvas = canvasRef.current;
    pointerRef.current = null;
    if (canvas.hasPointerCapture(event.pointerId)) {
      canvas.releasePointerCapture(event.pointerId);
    }
    setFirmada(true);
    onChange(canvas.toDataURL("image/png"));
  };

  const limpiar = () => {
    const canvas = canvasRef.current;
    canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    setFirmada(false);
    onChange(null);
  };

  return { canvasRef, firmada, iniciar, dibujar, terminar, limpiar };
}
